export const getLabels = () => ({
  certificationDescription: "You are already registered as a certified operator. Here you can view your registrations, add new ones, or delete the existing ones.",
  title: "Delete registration",
  description: "Confirm to delete the registration",
  createdSuccess: "Dissociation successful",
  createdFailed: "Sorry, dissociation failed",
  confirm: "Confirm",
  cancel: "Cancel",
  installerCode: "Installer Code",
  loading: "Loading...",
  servicePartner: "Service Partner",
  baseCertificationInstaller: "Base Certified operator",
  advancedCertificationInstaller: "Advanced Certified operator",
});

export const labels = getLabels();
